import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { UserOrderContext } from 'context/context';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FoodItemListHandlers from 'organisms/CartPage/Presentation/ReusableComponents/FoodItemListHandlers';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import { MENU_PLP_CONSTANT_DATA } from 'common/utilities/menuPLPModulator';

const CustomizationAlert = () => {
  const { ALERT_TEXT, ALERT_CONFIRM_TEXT, ALERT_CANCEL_TEXT } = MENU_PLP_CONSTANT_DATA;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const history = useHistory();
  const dispatch = useDispatch();
  const { showCartAlert } = FoodItemListHandlers(
    undefined,
    undefined,
    undefined,
    undefined,
    userOrderStateDispatch,
    dispatch,
    undefined,
  );
  const navigateToCart = () => {
    showCartAlert(false);
    history.push({
      pathname: '/cart',
    });
    window.scrollTo(0, 0);
  };
  const cartALertRenderElement = (
    <CartAlertFormInsideModel
      handleClose={() => showCartAlert(false)}
      classNames=''
      CartAlertForm={
        <CartAlertForm
          title={translateWithI18Next(ALERT_TEXT)}
          confirmButtonText={translateWithI18Next(ALERT_CONFIRM_TEXT)}
          cancelButtonText={translateWithI18Next(ALERT_CANCEL_TEXT)}
          cancelHandler={() => showCartAlert(false)}
          confirmHandler={() => navigateToCart()}
        />
      }
    />
  );

  return ReactDOM.createPortal(cartALertRenderElement, document.getElementById('modal-popups'));
};

export default CustomizationAlert;
